module.exports = __webpack_public_path__ + "static/1-4f90f6cd245914f2c597f0fc3cdc6bbd.png";